module.exports = __webpack_public_path__ + "img/4w1.32fcef12.jpg";